import React from "react"
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';

export const TextFieldHelper = ({n, value, onChange, label, type, autoFocus, rowsMax, multiline, rows, helper, disabled}) => {
    if(n === undefined) {
        return <TextField
                value={value || ''}
                onChange={onChange}
                label={label}
                type={type !== undefined ? type : "text"}
                fullWidth
                rows={rows}
                rowsMax={rowsMax}
                multiline={multiline}
                helperText={helper}
                disabled={disabled}
            />
    }
    return (
        <Grid item xs={n}>
            <TextField
                value={value || ''}
                onChange={onChange}
                label={label}
                type={type !== undefined ? type : "text"}
                fullWidth
                rows={rows}
                rowsMax={rowsMax}
                multiline={multiline}
                helperText={helper}
                disabled={disabled}
            />
        </Grid>
    )
}

export const SelectFieldWrapper = ({n, name, children}) => {
    if(n === undefined) {
        return <FormControl fullWidth>
                <InputLabel htmlFor={name}>{name}</InputLabel>
                {children}
            </FormControl>
    }
    return (
        <Grid item xs={n}>
            <FormControl fullWidth>
                <InputLabel htmlFor={name}>{name}</InputLabel>
                {children}
            </FormControl>
        </Grid>
    )
}

export const SelectFieldWrapperExtended = ({n, name, children, value, handleChange, items, disabled}) => {
    return (
        <Grid item xs={n}>
            <FormControl fullWidth>
                <InputLabel htmlFor={name}>{name}</InputLabel>
                <Select
                    key={value+name}
                    value={value}
                    onChange={handleChange}
                    autoWidth
                    disabled={disabled}
                    classes={{
                        root: "selectMenu"
                    }}
                >
                    {items && items.map((item) => (
                        <MenuItem className="menuItem" value={item.val}>{item.farbe && <div className="miniFarbe" style={{backgroundColor: item.farbe}} />}{item.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    )
}

export const SwitchFieldWrapper = ({n, checked, name, onChange, disabled}) => {
    return (
        <Grid item xs={n} className="alignBottom">
            <Switch
                disabled={disabled}
                key={name+"aktiv"}
                checked={checked}
                onChange={onChange}
                value="aktiv"
            /> {name}
        </Grid>
    )
}


export const CheckboxFieldWrapper = ({n, down, disabled, checked, name, onChange}) => {
    var checkbox = (
        <div>
            <FormControlLabel
                control={
                    <Checkbox
                        key={name+"Checkbox"+checked}
                        checked={checked}
                        onChange={onChange}
                        value="aktiv"
                        disabled={disabled}
                    />
                }
                label={!down && name}
            />
            {down && <div>{name}</div>}
        </div>
    )
    if(n===undefined) {
        return checkbox
    }
    return (
        <Grid item xs={n}>
            {checkbox}
        </Grid>
    )
}



// WEBPACK FOOTER //
// ./src/Components/Fields.js